import React, { useState } from "react";
import { Box, Typography, Button, Avatar, Chip, Container } from "@mui/material";
import profilPhoto from "../img/Harvest-Jee-profil.jpg";

const CallToAction = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      id="about-avg"
      sx={{
        backgroundColor: "#014527",
        backgroundImage: "radial-gradient(circle at 15% 15%, rgba(16, 185, 129, 0.12) 0%, transparent 45%), radial-gradient(circle at 85% 85%, rgba(245, 158, 11, 0.1) 0%, transparent 45%)",
        color: "white",
        textAlign: "center",
        py: { xs: 6, md: 8 },
        px: 2
      }}
    >
      <Container maxWidth="md">
        {/* Badge & Titre principal */}
        <Chip
          label="PRÉSENTATION DE L'ENTREPRISE"
          size="small"
          sx={{
            bgcolor: "rgba(245, 158, 11, 0.15)",
            color: "#fbbf24",
            fontWeight: 700,
            fontSize: "0.75rem",
            mb: 1.5,
            border: "1px solid rgba(245, 158, 11, 0.3)"
          }}
        />

        <Typography variant="h3" sx={{ mb: 1.5, fontWeight: "bold", fontSize: { xs: "2rem", md: "2.6rem" } }}>
          Qui sommes-nous ?
        </Typography>

        <Typography variant="subtitle1" sx={{ color: "#34d399", fontWeight: 700, mb: 2.5, fontSize: "1.1rem" }}>
          Structurer la production agricole gabonaise
        </Typography>

        {/* Description actualisée d'après le dossier de présentation */}
        <Typography
          variant="body1"
          sx={{
            mb: 2.5,
            mx: "auto",
            fontSize: { xs: "0.95rem", md: "1.05rem" },
            lineHeight: "1.7",
            color: "rgba(255, 255, 255, 0.9)"
          }}
        >
          <strong>Agri Vision Gabon (AVG)</strong> est une entreprise gabonaise engagée dans l’organisation, 
          l’accompagnement et la valorisation de la production agricole locale. 
          Notre objectif est de contribuer à une agriculture mieux structurée, capable de répondre plus régulièrement aux besoins du marché, 
          grâce à un modèle intégré associant producteurs, accompagnement agronomique, approvisionnement en plants, 
          outils numériques (AVG Farm) et commercialisation.
        </Typography>

        {/* Piliers Mission / Vision / Approche en pastilles compactes */}
        <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 1.5, mb: 4 }}>
          <Box sx={{ bgcolor: "rgba(255, 255, 255, 0.08)", px: 2, py: 1.2, borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.12)", maxWidth: 260 }}>
            <Typography variant="caption" sx={{ color: "#34d399", fontWeight: 800, display: "block" }}>
              NOTRE MISSION
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "0.78rem", lineHeight: 1.3 }}>
              Accompagner les producteurs de l’organisation jusqu’à la commercialisation.
            </Typography>
          </Box>

          <Box sx={{ bgcolor: "rgba(255, 255, 255, 0.08)", px: 2, py: 1.2, borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.12)", maxWidth: 260 }}>
            <Typography variant="caption" sx={{ color: "#fbbf24", fontWeight: 800, display: "block" }}>
              NOTRE VISION
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "0.78rem", lineHeight: 1.3 }}>
              Une agriculture mieux organisée, productive et connectée au marché.
            </Typography>
          </Box>

          <Box sx={{ bgcolor: "rgba(255, 255, 255, 0.08)", px: 2, py: 1.2, borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.12)", maxWidth: 260 }}>
            <Typography variant="caption" sx={{ color: "#60a5fa", fontWeight: 800, display: "block" }}>
              NOTRE APPROCHE
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "0.78rem", lineHeight: 1.3 }}>
              Renforcer les exploitations existantes sans se substituer aux producteurs.
            </Typography>
          </Box>
        </Box>

        {/* Vidéo de présentation */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 4.5,
            width: "100%",
            maxWidth: "600px",
            mx: "auto"
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.35)",
              border: "1px solid rgba(255, 255, 255, 0.15)"
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0
              }}
              src="https://www.youtube.com/embed/99BAvYG1UJY"
              title="3 min pour comprendre AgriVision Gabon"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Box>

        {/* Description intégrale de la CEO & Fondatrice */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            bgcolor: "rgba(255, 255, 255, 0.06)",
            border: "1px solid rgba(255, 255, 255, 0.12)",
            borderRadius: "20px",
            p: { xs: 3, sm: 4 },
            textAlign: "center"
          }}
        >
          <Avatar
            src={profilPhoto}
            alt="Jeeanne Moudoumbi Kengue"
            sx={{
              width: 120,
              height: 120,
              border: "3px solid #10b981",
              boxShadow: "0 4px 15px rgba(16, 185, 129, 0.35)",
              mb: 2
            }}
          />

          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#ffffff", mb: 0.5 }}>
            Jeeanne Moudoumbi Kengue
          </Typography>

          <Typography variant="subtitle2" sx={{ color: "#34d399", fontWeight: 700, mb: 2 }}>
            Fondatrice & CEO — Agri Vision Gabon
          </Typography>

          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontStyle: "italic",
              fontWeight: 700,
              fontSize: { xs: "1.1rem", md: "1.25rem" },
              color: "#fbbf24",
              mb: 2.5
            }}
          >
            "Ensemble, bâtissons un avenir agricole durable"
          </Typography>

          <Box
            sx={{
              maxWidth: "720px",
              textAlign: "left",
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "0.95rem",
              lineHeight: 1.7
            }}
          >
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
              Au Gabon, j’ai grandi face à des réalités qui vous parleront sûrement : le chômage qui touche nos jeunes diplômés, 
              l’augmentation constante des prix alimentaires et la disparition de ces aliments sains que nos familles consommaient autrefois. 
              Nos campagnes se vident peu à peu à cause de l’exode rural, affaiblissant un secteur agricole pourtant essentiel à notre survie.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
              Comme beaucoup d’entre vous, le système scolaire général ne me correspondait pas vraiment. Pourtant, cette période a éveillé en moi une réflexion profonde : 
              pourquoi ne pas agir pour transformer ces difficultés en opportunités ?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
              Mon parcours m’a conduite en France, où j’ai décidé de me former dans l’agriculture pour revenir aux sources et contribuer au développement de solutions durables. 
              À travers un <strong>CAP Agricole</strong> pour apprendre les bases du métier et un <strong>Responsable de productions légumières, fruitières, florales et de pépinières (BP)</strong>, 
              je me suis construite une vision claire : valoriser nos terres, nos savoir-faire et notre autonomie alimentaire.
            </Typography>

            {expanded && (
              <Box sx={{ pt: 1, borderTop: "1px solid rgba(255, 255, 255, 0.15)", mt: 2 }}>
                <Typography variant="subtitle1" sx={{ color: "#34d399", fontWeight: 800, mb: 1 }}>
                  Un projet pour tous
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                  Ce projet, c’est aussi le vôtre. Ensemble, nous pouvons réduire la dépendance aux importations, revitaliser nos campagnes 
                  et offrir aux générations futures un avenir agricole prospère. Rejoignez-moi dans cette aventure et contribuons, main dans la main, 
                  à bâtir un Gabon plus résilient et indépendant.
                </Typography>

                {/* 3 piliers d'action issus du dossier officiel */}
                <Box sx={{ bgcolor: "rgba(0, 0, 0, 0.2)", p: 2, borderRadius: "12px", borderLeft: "3px solid #10b981", mt: 2 }}>
                  <Typography variant="subtitle2" sx={{ color: "#ffffff", fontWeight: 800, mb: 1 }}>
                    Notre ambition au quotidien :
                  </Typography>
                  <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.85)", fontSize: "0.85rem", lineHeight: 1.6 }}>
                    • <strong>Mieux connaître</strong> pour mieux planifier.<br />
                    • <strong>Mieux accompagner</strong> pour mieux produire.<br />
                    • <strong>Mieux organiser</strong> pour mieux commercialiser.
                  </Typography>
                </Box>
              </Box>
            )}

            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Button
                variant="text"
                onClick={() => setExpanded(!expanded)}
                sx={{
                  color: "#34d399",
                  fontWeight: 700,
                  textTransform: "none",
                  fontSize: "0.9rem",
                  "&:hover": { bgcolor: "rgba(52, 211, 153, 0.1)" }
                }}
              >
                {expanded ? "Voir moins ▲" : "Lire la suite ▼"}
              </Button>
            </Box>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "#fbbf24",
              fontStyle: "italic",
              fontWeight: 700,
              mt: 2,
              pt: 2,
              borderTop: "1px solid rgba(255, 255, 255, 0.1)",
              width: "100%",
              maxWidth: 500
            }}
          >
            « Cultivons l’espoir, récoltons l’avenir. »
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToAction;
